import type { ProductInfo } from "@b2bportal/chat-api";
import { PATH_TRIPS } from "@hopper-b2b/utilities";

export function postProcessAgentMessage(message: string) {
  // converts the `/n` characters embedded in the message into
  // two spaces which markdown can parse as a new line
  return message.replace(/\n/gi, "\n &nbsp;");
}

export const getBaseTripDetailsPath = (productInfo: ProductInfo) =>
  `${PATH_TRIPS}?tripId=${productInfo.itineraryUuid}`;
